export const StatusName = {
  Finished: "Zakończone",
};
